import { applySequentialPlacement } from './applySequentialPlacement'
import { AutoArrangeHandler } from './types'

export const arrangeItemsByName: AutoArrangeHandler = (items, cols, rows) => {
  const sortedItems = [...items].sort((a, b) => a.label.localeCompare(b.label))
  return applySequentialPlacement(sortedItems, cols, rows, items)
}
